import { Box, Button, withStyles } from '@material-ui/core';
import FsSubtitle from 'ui-elements/typography/FsSubtitle';

export const WrapperBox = withStyles(() => ({
  root: {},
}))(Box);

export const MainRowBox = withStyles(({ spacing, breakpoints }) => ({
  root: {
    marginBottom: spacing(2),
    [breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },
}))(Box);

export const SidePanelTriggerButton = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    maxHeight: 0,
    opacity: 0,
    transition: `max-height .3s linear, opacity .3s linear`,
    marginLeft: -10,
  },
}))(Box);

export const StyledIconButtonWrapper = withStyles(
  ({ spacing, breakpoints }) => ({
    root: {
      position: 'absolute',
      top: spacing(2.4),
      left: spacing(2),
      [breakpoints.up('sm')]: {
        position: 'static',
      },
    },
  })
)(Box);

export const StyledIconButton = withStyles(({ spacing, breakpoints }) => ({
  root: {
    padding: spacing(0.5),
    borderRadius: spacing(1),
    '&:hover': {
      background: 'transparent',
    },
  },
}))(Button);

export const TitleBox = withStyles(({ breakpoints, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(2),
    [breakpoints.up('sm')]: {
      marginTop: spacing(0),
      justifyContent: 'center',
    },
  },
}))(Box);

export const ActionButtonsBox = withStyles(({ breakpoints, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: spacing(2.4),
    right: spacing(2),
    [breakpoints.up('sm')]: {
      top: spacing(4.4),
      right: spacing(6),
    },
    [breakpoints.up('md')]: {
      position: 'static',
    },
  },
}))(Box);

export const DateWrapper = withStyles(({ palette, spacing }) => ({
  root: {
    position: 'relative',
    paddingLeft: spacing(1.2),
    marginLeft: spacing(1.2),
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: 0,
      transform: 'translate(-50%, -50%)',
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: palette.grey[300],
    },
  },
}))(Box);

export const Title = withStyles(() => ({
  root: {},
}))(FsSubtitle);
